import {enGB as en, sv, fi} from 'date-fns/locale';
import {getLocale} from '../../services/i18n/locale';
import {formatInTimeZone} from 'date-fns-tz';

const locales = {en, sv, fi};
const timeZone = 'Europe/Stockholm';
export function format(date: Date, dateFormat = 'PP') {
    return formatInTimeZone(date, timeZone, dateFormat, {
        locale: locales[getLocale()]
    });
}

export function formatDay(date: Date, t: (key: string) => string) {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    if (date.toDateString() === today.toDateString()) {
        return t('time.today');
    }
    if (date.toDateString() === tomorrow.toDateString()) {
        return t('time.tomorrow');
    }
    return format(date, 'eee d MMM');
}
